import React, { useEffect, useState } from 'react'
import injectStyles from 'react-jss'

import InputLabel from '@material-ui/core/InputLabel'
import { IconButton, Input, InputAdornment } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import { validPassword } from '../../../shared/validation'

import { styles } from './styles'
import { AUTH_METHOD } from '../../../constants'

const validationPassMessage =
  'Minimum 8 characters, one lower case, one upper case, one number.'

const InputPasswordStyled = ({
  authMethod,
  label = 'Password',
  classes,
  value,
  onChange,
  required = true,
  disableValidation = false,
  isTouched: isTouchedProps,
  placeholder = '',
  cypress_id,
  onSubmit,
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const [isTouched, setIsTouched] = useState(false)
  const [error, setError] = useState('')

  const isAuthMethodPromofy = authMethod === AUTH_METHOD.OPPIZI
  useEffect(() => {
    if (isTouchedProps) {
      setIsTouched(true)
    }
  }, [isTouchedProps])

  useEffect(() => {
    if (isTouched) {
      if (required && isTouched && !value.trim()) {
        setError('required')
      }
    }
  }, [isTouched])

  const onInputChange = value => {
    let error = ''

    if (value) {
      const errorMessage = validPassword(value, {
        minLength: validationPassMessage,
        minLowercase: validationPassMessage,
        minUppercase: validationPassMessage,
        minNumber: validationPassMessage,
      })
      if (errorMessage && !disableValidation) {
        error = errorMessage
      } else {
        error = ''
      }
    }

    if (required && isTouched && !value.trim()) {
      error = 'required'
    }

    setError(error)
    onChange(value, error)
  }

  return (
    <div className={classes.wrap} style={{ marginBottom: '4px' }}>
      <InputLabel className={classes.label}>
        <span>
          {label} {required ? <span style={{ color: 'red' }}>*</span> : null}
        </span>
      </InputLabel>
      <Input
        className={classes.input}
        value={value}
        onChange={event =>
          isAuthMethodPromofy && onInputChange(event.target.value)
        }
        disableUnderline={true}
        type={showPassword ? 'text' : 'password'}
        autoComplete="new-password"
        onBlur={() => setIsTouched(true)}
        placeholder={placeholder || label}
        cypress_id={cypress_id}
        endAdornment={
          <InputAdornment
            position="start"
            style={{ position: 'absolute', right: 0 }}
          >
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(prev => !prev)}
              onMouseDown={event => {
                event.preventDefault()
              }}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {error ? (
        <div className={classes.error}>{error}</div>
      ) : (
        <div className={classes.emptyMargin} />
      )}
    </div>
  )
}

export default injectStyles(styles)(InputPasswordStyled)
